import { render, staticRenderFns } from "./UserIcon.vue?vue&type=template&id=26701a76&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=ts"
export * from "./UserIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26701a76",
  null
  
)

export default component.exports